/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResultDocumentFile
 */
export interface ResultDocumentFile {
    /**
     * 
     * @type {number}
     * @memberof ResultDocumentFile
     */
    resultDocumentFileId?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultDocumentFile
     */
    fileUuid?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultDocumentFile
     */
    fileType?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultDocumentFile
     */
    fileExtension?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultDocumentFile
     */
    mimeType?: string;
}

/**
 * Check if a given object implements the ResultDocumentFile interface.
 */
export function instanceOfResultDocumentFile(value: object): value is ResultDocumentFile {
    return true;
}

export function ResultDocumentFileFromJSON(json: any): ResultDocumentFile {
    return ResultDocumentFileFromJSONTyped(json, false);
}

export function ResultDocumentFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultDocumentFile {
    if (json == null) {
        return json;
    }
    return {
        
        'resultDocumentFileId': json['resultDocumentFileId'] == null ? undefined : json['resultDocumentFileId'],
        'fileUuid': json['fileUuid'] == null ? undefined : json['fileUuid'],
        'fileType': json['fileType'] == null ? undefined : json['fileType'],
        'fileExtension': json['fileExtension'] == null ? undefined : json['fileExtension'],
        'mimeType': json['mimeType'] == null ? undefined : json['mimeType'],
    };
}

export function ResultDocumentFileToJSON(json: any): ResultDocumentFile {
    return ResultDocumentFileToJSONTyped(json, false);
}

export function ResultDocumentFileToJSONTyped(value?: ResultDocumentFile | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'resultDocumentFileId': value['resultDocumentFileId'],
        'fileUuid': value['fileUuid'],
        'fileType': value['fileType'],
        'fileExtension': value['fileExtension'],
        'mimeType': value['mimeType'],
    };
}

